"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_bucket_endpoint_middleware = require("@aws-sdk/bucket-endpoint-middleware");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var PutBucketAccelerateConfiguration_1 = require("../model/PutBucketAccelerateConfiguration");
var PutBucketAccelerateConfigurationCommand = /** @class */ (function () {
    function PutBucketAccelerateConfigurationCommand(input) {
        this.input = input;
        this.model = PutBucketAccelerateConfiguration_1.PutBucketAccelerateConfiguration;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    PutBucketAccelerateConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_bucket_endpoint_middleware.bucketEndpointMiddleware({
            forcePathStyle: configuration.forcePathStyle,
            preformedBucketEndpoint: configuration.bucketEndpoint,
            useAccelerateEndpoint: configuration.useAccelerateEndpoint,
            useDualstackEndpoint: configuration.useDualstackEndpoint
        }), {
            step: "build",
            priority: 0
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return PutBucketAccelerateConfigurationCommand;
}());
exports.PutBucketAccelerateConfigurationCommand = PutBucketAccelerateConfigurationCommand;
//# sourceMappingURL=PutBucketAccelerateConfigurationCommand.js.map